import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { guaranteesClientText } from '~/modules/guarantees/form/client/constants.ts';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import StatusFlowContent from './StatusFlowContent.tsx';
import type { IGuaranteesApplicationStatusFlowProps } from './types.ts';
import { buildStatusFlowNodes } from './utils.ts';

const GuaranteesApplicationStatusFlow: React.FC<IGuaranteesApplicationStatusFlowProps> = ({
  events,
  isLoading = false,
}) => {
  const nodes = useMemo(() => buildStatusFlowNodes(events), [events]);
  const shouldRender = isLoading || !!nodes.length;
  const content = <StatusFlowContent isLoading={isLoading} nodes={nodes} />;

  return shouldRender ? (
    <Box sx={guaranteesClientPageStyles.statusFlowWrap}>
      <Box sx={guaranteesClientPageStyles.statusFlowHeader}>
        <Typography sx={guaranteesClientPageStyles.statusFlowTitle}>
          {guaranteesClientText.applicationTimelineTitle}
        </Typography>
      </Box>
      <Box sx={guaranteesClientPageStyles.statusFlowBody}>{content}</Box>
    </Box>
  ) : null;
};

export default GuaranteesApplicationStatusFlow;
